<h1>{{title}}</h1>
<div *ngIf="selectedPayout" fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <h3>Prize Fund: {{this.flighted | currency}}</h3>
        <mat-radio-group [(ngModel)]="selectedPayout.pay_type">
            <mat-radio-button [value]='0'>%</mat-radio-button>
            <mat-radio-button [value]='1'>$</mat-radio-button>
        </mat-radio-group>
    </div>
    <div fxLayout="column" fxLayoutGap="10px">
        <div *ngFor="let value of selectedPayout.payouts; let i=index; trackBy: trackByFn" fxLayout="start bottom" fxLayoutGap="10px">
            <div class="payout_field">
                {{i+1}} -
            </div>
            <div>
                    <input matInput [(ngModel)]='selectedPayout.payouts[i]'>
            </div>
            <div>
                {{selectedPayout.pay_type==0? '%': '$'}}
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" *ngIf="!saving">
        <button mat-raised-button color="primary" (click)="save()">Save</button>
        <button mat-raised-button (click)="close(null)">Close</button>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" *ngIf="saving">
          Saving  <i class="fa fa-spiner fa-spin"></i>
    </div>
    
</div>
<div fxLayout="column" fxLayoutAlign="center center" *ngIf="!selectedPayout" fxLayoutGap="10px" style="height: 100px;">
    Loading Payouts ...
    <i class="fa fa-spiner fa-spin"></i>
</div>